// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"edb3a025","465":"c956a019"}[chunkId] + ".chunk.js";
};